import type { NotifyPort } from '@/features/messages/domain/notify'
import type { MemberPort } from '../domain/member'

const archiveMember = async (port: MemberPort, id: string, notify: NotifyPort): Promise<void> => {
	try {
		await port.archive(id)
	} catch {
		notify.error('hr.memberArchiveFailed')
		throw new Error('Failed to archive team member.')
	}
}

export { archiveMember }
